import authActions from "./actions";
import commonActions from "../common/actions";
import { takeEvery, call, all, put, delay, select } from "redux-saga/effects";
import axios from "axios";
// import { API_URL } from "../../utils/constants";
import Cookies from "js-cookie";
import candidatesActions from "../../redux/candidates/actions";
import { InternalError,ExternalError } from "../../common/ErrorMessage";
import {transformCandidateArray} from '../../utils/CacheHelper';

import {
  DecryptFunction,
  EncryptFunction,
  EncryptObjectFunction,
} from "../../utils/cryptoFunction";
import {
  handleDecodeJSON,
  handleEncodeJson,
} from "../../utils/encodeDecodeJson";
import keycloakService from "../../modules";
import { useNavigate } from "react-router-dom";
import {store} from "../store";

const authSagas = function* () {
  yield all([
     yield takeEvery(authActions.GET_PROFILE_SUMMARY, profileSummary),
     yield takeEvery(authActions.GET_MOBILE_VERIFIED, mobileverified),
     yield takeEvery(authActions.GET_ALL_MENU, allMenu),
    yield takeEvery(authActions.CHECK_MOBILE_VERIFIED, checkmobileVerified),

    yield takeEvery(authActions.CANDIDATE_TOKEN_VERIFY, candidateTokenVerify),

    yield takeEvery(authActions.CANDIDATE_LOGOUT, candidateLogout),
    yield takeEvery(authActions.VERIFY_OTP,verifyOtp),
    yield takeEvery(
      authActions.VERIFY_MOBILENO_FOR_SIGNUP,
      verifyMobilenoForSignup
    ),
    yield takeEvery(
      authActions.GET_PROFILE_REGISTRATION_ACTIVE_TAB,
      getProfileRegistrationActiveTab
    ),
    yield takeEvery(
      authActions.CHECK_CANDIDATE_MOBILENO,
      checkCandidateMobileno
    ),
    yield takeEvery(
      authActions.SEND_OTP_FOR_MOBILE_VERIFICATION,
      sendOtpForMobileVerification
    ),
    yield takeEvery(
      authActions.CHECK_DUPLICATE_EMAIL_OR_MOBILENO,
      checkDuplicateEmailOrMobileno
    ),
    yield takeEvery(
      authActions.GET_TEMP_CANDIDATE_DETAILS,
      getTempCanidateDetails
    ),
  ]);
};
const checkmobileVerified = function* (data) {
  const { payload } = data;
  const { setMobileVerified, dispatch, setOpenDialog, navigate,setResendCountdown } = payload;
      yield put({ type: commonActions.SET_DASHBOARD_PAGE_LOADER, payload: true });

  yield delay(1000);
  
  yield put({ type: commonActions.SET_DASHBOARD_PAGE_LOADER, payload: false });
  const uploadDetails = yield select(
    (state) => state.candidatesReducer.uploadDetails
  );
  

  const allProfiledetailsDraft = uploadDetails?.[0]?.statusmain ? true : false;


if (allProfiledetailsDraft) {
  localStorage.setItem('uploaddetails', 'true', { expires: 7,secure: true,sameSite: 'Strict' }); 
}
  try {
    const encryptedData = yield call(handleEncodeJson, {
      encodeJSON: payload?.data,
    });
    const result = yield call(async () => {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/check-mobileverified`,
        encryptedData
      );
      return response; 
    });


    if (result?.data?.statusCode === 200) {
      localStorage.setItem("mhet_cnd_email", result?.data?.data?.emailid);
      localStorage.setItem("mhet_cnd_mobileno", result?.data?.data?.mobileno);
      if(!allProfiledetailsDraft){
        navigate(`/${localStorage.getItem("mhet_cnd_project")}/registration?page=personaldetails`)
      }
      else{
        navigate(`/${localStorage.getItem("mhet_cnd_project")}/home`);
      }
      yield put({ type:  "SIGNUP_SUCCESS", payload: result.data });
    } 
    else if(result?.data?.statusCode === 409){

      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        }
      });

      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        }
      });
    yield put({ type:authActions?.CANDIDATE_LOGOUT})
     
      
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          show: false,
        }
      });
    }
    
    else {


      setOpenDialog(true);
      yield put({ type: "SIGNUP_FAILED", payload: result.data });
      dispatch({
        type: authActions.SEND_OTP_FOR_MOBILE_VERIFICATION,
        payload: {
          data: {
            mobileno: localStorage.getItem("mhet_cnd_mobileno"),
            candidatename:payload?.data?.candidatename
          },
        },
      });
      setResendCountdown(120)
    }
    yield put({ type: commonActions.SET_CLICKABLE, payload: true });

  } catch (error) {

    if (error.response) {
      console.error("Error response data:", error.response.data);
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Error message:", error.message);
    }

    yield put({ type: "SIGNUP_ERROR", payload: error.message });
  }
};


const candidateLogout = function* (data) {

  try {
    let token = localStorage.getItem("mhet_cnd_token");
    if (token) {
      const result = yield call(() =>
        axios.post(`${process.env.REACT_APP_API_URL}/candidate/logout`, { token: token })
      );

        localStorage.removeItem("mhet_cnd_email");
  localStorage.removeItem("mhet_cnd_email_verified");
  localStorage.removeItem("mhet_cnd_mobileno");
  localStorage.removeItem("mhet_cnd_mobileno_otp");
  localStorage.removeItem("mhet_cnd_mobileno_verified");
  localStorage.removeItem("mhet_cnd_project");
  localStorage.removeItem("mhet_cnd_token");
  localStorage.removeItem("profile_completed")
  localStorage.removeItem("uploaddetails")
  localStorage.removeItem("mobileotp")

      keycloakService.doLogout()
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      if (result?.data?.statusCode === 200) {
      }
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: { status: null, show: false, message: null },
      });
    }else{
      keycloakService.doLogout()
    }
  } catch (error) {
    localStorage.removeItem("mhet_cnd_token");
    window.location.href = `/${localStorage.getItem("mhet_cnd_project")}/login`;
  }
};

const allMenu=function* (){
 try {
 yield put({ type: commonActions.SET_DASHBOARD_PAGE_LOADER, payload: true });
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/candidate/menus`
        )
      ); 
       yield put({ type: commonActions.SET_DASHBOARD_PAGE_LOADER, payload: false });
      const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    }); 
     if (result?.data?.statusCode === 200) {
        const allMenuData = decryptedData;
        yield put({
          type: authActions.SET_ALL_MENU,
          payload: allMenuData,
        });
         }

  } catch (err) {
     yield call(InternalError,err)
     
  }
}
const profileSummary = function* (action) {
  const navigate = action?.payload?.navigate;
  let sso=keycloakService?.keycloakTokenParsed()?.sub;
  try {
 yield put({ type: commonActions.SET_DASHBOARD_PAGE_LOADER, payload: true });
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/candidate/profile-summary`
        )
      );
      // const decryptedData = yield call(handleDecodeJSON, {decodeJSON:result?.data?.result});
      yield put({ type: commonActions.SET_DASHBOARD_PAGE_LOADER, payload: false });
      const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
      if (result?.data?.statusCode === 200) {
        // const profileData = result?.data?.result;
        const profileData = decryptedData;
        
       if (Array.isArray(profileData) && profileData.length > 0) {
        const profile = profileData[0];

        localStorage.setItem("mhet_cnd_email", profile?.emailid);
        // localStorage.setItem("mhet_cnd_mobileno", profile?.mobileno);

        yield put({ type: "SIGNUP_SUCCESS", payload: result.data });

        if (profile?.uploaddetailstatus === 2) {
          localStorage.setItem('uploaddetails', 'true', { expires: 7, secure: true, sameSite: 'Strict' });
        }

        yield put({
          type: authActions.SET_PROFILE_SUMMARY,
          payload: profileData,
        });

        yield put({
          type: authActions.SET_CANDIDATE_TOKEN_DETAILS,
          payload: transformCandidateArray(profileData),
        });

        // if (profile?.mobilenoverified) {
          yield put({ type: commonActions.SET_CLICKABLE, payload: true });
        
      } else{
        //  yield put({type:authActions.VERIFY_MOBILENO_FOR_SIGNUP,
        //         payload: { data: { emailid: localStorage.getItem('mhet_cnd_email'),
        //           dob:localStorage.getItem('mhcet_dob'),
        //           candidatename:localStorage.getItem('mhcet_name'),
        //           sso:sso, navigate: navigate } },})
      }
      
      // ✅ If result is empty, skip all above without showing toast
      yield call(ExternalError, result);
    }

  } catch (err) {
     yield call(InternalError,err)
     
    //  yield put({ type:authActions?.CANDIDATE_LOGOUT})
     yield put({ type: "SIGNUP_ERROR", payload: err.message });
  }
};
const mobileverified=function* (action) {
  const { navigate } = action.payload;
  const Token=localStorage.getItem('mhet_cnd_token');
  const courseId = localStorage.getItem("courseid")
  try {
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/candidate/mobile-verified/${encodeURIComponent(EncryptFunction(courseId))}`,{
          headers: {
            authorization: `Bearer ${Token}`,
          }})
      );
      const decryptedData = yield call(handleDecodeJSON, {decodeJSON:result?.data?.result});
      
      if (result?.data?.statusCode === 200) {
        yield put({
          type: authActions.SET_MOBILE_VERIFIED,
          payload:decryptedData[0],
        });
        yield put({type:authActions.CANDIDATE_TOKEN_VERIFY})
      }

      if (result?.data?.statusCode === 204) {
      // window.location.href = 'https://clp-stag-2025.hubblehox.ai/';
      window.location.href = `${process.env.REACT_APP_KEYCLOAK_REDIRECT_URI}`;
      }
      yield call(ExternalError,result)
    

  } catch (err) {
     yield call(InternalError,err)
  }
};
const candidateTokenVerify = function* () {
  try {
    const { profileSummary } = yield select(
      (state) => state.authReducer
    );
    const Token=localStorage.getItem("mhet_cnd_token")
    if (!profileSummary) {
      const result = yield call(() =>
        axios.get(`${process.env.REACT_APP_API_URL}/candidate/verify-token`,{
          headers: {
            authorization: `Bearer ${Token}`,
          }})
      );
      const decryptedData = yield call(handleDecodeJSON, {decodeJSON:result?.data?.result});
      if (result?.data?.statusCode === 200) {
        yield put({
          type: authActions.SET_CANDIDATE_TOKEN_DETAILS,
          payload:decryptedData[0],
        });
      } else {
      }
      yield call(ExternalError,result)
    }

  } catch (err) {
    localStorage.removeItem("mhet_cnd_token");
     yield call(InternalError,err)
  }
};

const sendOtpForMobileVerification = function* (data) {
   const { payload } = data;
  const Token=localStorage.getItem('mhet_cnd_token');
  const { mobileno } = payload.data;
   try {
   yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });

     const result = yield call(
      async () =>
        await axios.get(`${process.env.REACT_APP_API_URL}/candidate/check-mobileno/${encodeURIComponent(EncryptFunction(mobileno))}`,{
          headers: {
            authorization: `Bearer ${Token}`,
          }})
    );
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
    if (result?.data?.statusCode === 200) {

      yield put({
        type: commonActions.SET_ALERT,
       payload: {
          status: "success",
         show: true,
          message: result?.data?.message,
         },
       });
       yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: { status: null, show: false, message: null },
      });
    }else{

// //       // yield
// //       // localStorage.setItem("mhet_cnd_mobileno_otp", result?.data?.testotp);
// //       yield put({
// //         type: commonActions.SET_SHOW_MODAL,
// //         payload: {
// //           show: false,
// //           type: "EVS",
// //           method: "emailAndMobileVerification",
// //         },
// //       });
// //       yield put({
// //         type: commonActions.SET_SHOW_MODAL,
// //         payload: {
// //           show: true,
// //           type: "MV",
// //           method: "emailAndMobileVerification",
// //         },
// //       });
// //       // setResendCountdown(120);
//       //   navigate(`/${localStorage.getItem("mhet_cnd_project")}/verify-mobileno`);
//     // }
 yield put({
   type: commonActions.SET_ALERT,
   payload: {
    status: "failed",
     show: true,
     message: result?.data?.message,
   },
 });
 yield delay(2000);
 yield put({
  type: commonActions.SET_ALERT,
   payload: { status: null, show: false, message: null },
 });
}
 } catch (err) {
   yield call(InternalError,err)
  }
};
const getTempCanidateDetails = function* (data) {
  const { payload } = data;
  try {
    const result = yield call(() =>
      axios.get(`${process.env.REACT_APP_API_URL}/candidate/get/mobileno/${encodeURIComponent(EncryptFunction(payload?.emailid))}`)
    );
    if (result) {
      yield put({
        type: authActions.SET_TEMP_CANDIDATE_DETAILS,
        payload: result?.data?.statusCode === 200 ? result?.data?.result : [],
      });
        yield call(ExternalError,result)
    }
  } catch (err) {
    yield call(InternalError,err)
  }
};
const verifyOtp = function* (data) {
  const { payload } = data;
  const Token=localStorage.getItem('mhet_cnd_token');
  const { otp, mobileno,setWrongotp, navigate,courseid,coursename,setOpen,setMobileVerified } = payload;
  try {
    // Encrypt only mobileno and otp, not whole payload
    const encryptedData = yield call(handleEncodeJson, {
      encodeJSON: { mobileno, otp },
    });

    const result = yield call(() =>
      axios.post(`${process.env.REACT_APP_API_URL}/candidate/mobileno-verify`, encryptedData,{
          headers: {
            authorization: `Bearer ${Token}`,
          }})
    );
    const decryptedData = yield call(handleDecodeJSON, {decodeJSON:result?.data});
    if (result?.data?.statusCode === 200) {
     yield put({
    type: authActions.SET_OTP_VERIFIED,
    payload: true,
  });
  // yield put({
  //       type: candidatesActions.GET_BYPASS_REGISTRATION,
  //       payload: {
  //         navigate,
  //         courseid,
  //         coursename,
  //         callback: () => {
  //           store.dispatch({ type: commonActions.SET_PAGE_LOADER, payload: false });
  //         },
  //       },
  //     });
  //      setOpen(false);
  // setMobileVerified(true);
  // yield put({ type: authActions.GET_MOBILE_VERIFIED });
  // navigate(`/${localStorage.getItem("mhet_cnd_project")}/registrations?courseid=${localStorage?.getItem("courseid")}&coursename=${localStorage?.getItem("coursename")}`)
    } else {
      // Failure case - show alert message
     setWrongotp((prev)=>prev+1);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: "failed",
          show: true,
          message: decryptedData?.message || "OTP verification failed.",
        },
      });
      // Optional: auto-dismiss after 2 seconds
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
    }
  } catch (err) {
    yield call(InternalError, err);
  }
};

const verifyMobilenoForSignup = function* (data) {
  const { payload } = data;

  const { navigate, emailid, dob, candidatename,sso } =
    payload.data;
  const email = localStorage.getItem("mhet_cnd_email");
  payload.emailid = email;

  try {
    const encryptedData = yield call(handleEncodeJson, {
      encodeJSON: payload?.data,
    });
    
    const result = yield call(() =>
      axios.post(`${process.env.REACT_APP_API_URL}/candidate/verify-mobileno`, encryptedData)
    );
    
    if (result?.data?.statusCode === 200) {
      // navigate(`/${localStorage.getItem("mhet_cnd_project")}/mobileno-verification`);
      // setMobileVerified(true);
      
      // navigate(`/${localStorage.getItem("mhet_cnd_project")}/registration?page=personaldetails`)
      // yield put({
      //   type: commonActions.SET_SHOW_MODAL,
      //   payload: {
      //     show: false,
      //     type: "Mv",
      //     method: "emailAndMobileVerification",
      //   },
      // });
      // yield put({type: candidatesActions.GET_PROFILE_PERSONAL_DETAILS})
      // yield put({
      //   type: commonActions.SET_SHOW_MODAL,
      //   payload: {
      //     show: true,
      //     type: "MVS",
      //     method: "emailAndMobileVerification",
      //   },
      // });
      // yield put({
      //   type: commonActions.SET_ALERT,
      //   payload: { status: null, show: false, message: null },
      // });
      // yield delay(2000);
      // yield put({
      //   type: commonActions.SET_SHOW_MODAL,
      //   payload: {
      //     show: false,
      //     type: "MVS",
      //     method: "emailAndMobileVerification",
      //   },
      // });
      // navigate(`/${localStorage.getItem("mhet_cnd_project")}/login`);
      // localStorage.setItem("mhet_cnd_mobileno_verified", true);
      // localStorage.removeItem("mhet_cnd_mobileno");
      localStorage.setItem("mhet_cnd_email_verified", false);
      yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });

      // setRed(false);
     } 
    // else {
    //   setWrongotp(wrongOTP + 1);
    //   setRed(true);
    // }
    // yield put({
    //   type: commonActions.SET_ALERT,
    //   payload: {
    //     status: result?.data?.statusCode === 200 ? "success" : "failed",
    //     show: true,
    //     message: result?.data?.message,
    //   },
    // });
    // yield delay(2000);
    // yield put({
    //   type: commonActions.SET_ALERT,
    //   payload: {
    //     status: null,
    //     show: false,
    //     message: null,
    //   },
    // });
    // setRed(false)
    // navigate(`/${localStorage.getItem("mhet_cnd_project")}/registration?page=personaldetails`)
  } catch (err) {
    yield call(InternalError,err)
  }
};

const getProfileRegistrationActiveTab = function* (data) {
  const { payload } = data;
   const candidateidid = yield select(
    (state) => state?.authReducer?.ProfileSummaryDetails[0]?.candidateid
  );

  try {
    const result = yield call(() =>
      axios.get(`${process.env.REACT_APP_API_URL}/candidate/profile-activetab/${encodeURIComponent(EncryptFunction(candidateidid))}`)
    );
    
        // const decryptedData = yield call(handleDecodeJSON, {
        //   decodeJSON: result?.data?.result?.encryptedData
        // });
    const decryptedData = yield call(handleDecodeJSON, {decodeJSON:result?.data?.result});

    yield put({
      type: authActions.SET_PROFILE_REGISTRATION_ACTIVE_TAB,
      payload: result?.data?.statusCode === 200 ? decryptedData[0] : [],
    });
      yield call(ExternalError,result)
  } catch (err) {
    yield call(InternalError,err)
  }
};

const checkCandidateMobileno = function* (data) {
  const { payload } = data;
  const { handleShowOtpInput, setForget, setResendCountdown, setVerified } =
    payload;

  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(`${process.env.REACT_APP_API_URL}/candidate/check-mobileno/${payload?.data}`)
    );
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    if (result?.data?.statusCode === 200) {
      localStorage.setItem(
        "mhet_cnd_forgetemail_otp",
        EncryptFunction(result?.data?.otp)
      );
      setForget(false);
      setResendCountdown(120);
      handleShowOtpInput();
      setVerified(false);
      yield delay(2000);
    }
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
    yield call(InternalError,err)
  }
  // yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

;

const checkDuplicateEmailOrMobileno = function* (data) {
  const { payload } = data;
  const { setAndClearError } = payload;

  try {
    const result = yield call(() =>
      axios.post(`${process.env.REACT_APP_API_URL}/candidate/check-duplicate`, payload?.data)
    );
    if (result?.data) {
      setAndClearError({ ...result?.data, type: payload?.data?.type });
    }
yield call(ExternalError,result)
  } catch (err) {
    yield call(InternalError,err)
  }
};




// const checkKeycloakSessionId = function* () {

//   yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
//   yield delay(1000)

//   try {
//   const candidateTokenDetails = yield select(
//     (state) => state?.authReducer?.candidateTokenDetails
//   );
//   const data = { candidateid: candidateTokenDetails?.candidateid }
//   const encodedData = yield call(handleEncodeJson,{encodeJSON:data});
//   // yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
//     const result = yield call(() =>
//       axios.post(`${process.env.REACT_APP_API_URL}/candidate/check-keycloak-sid`, encodedData)
//     );
//     // debugger
//     // yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
//     // yield put({
//     //   type: commonActions.SET_ALERT,
//     //   payload: {
//     //     status: result?.data?.statusCode === 200 ? "success" : "failed",
//     //     show: true,
//     //     message: result?.data?.message,
//     //   },
//     // });
//     if (result?.data?.statusCode === 200) {

//       const localSid = localStorage.getItem("mhet_cnd_sid");
//       const sid = result?.data?.sid

//       if (localSid != sid) {

//       localStorage.removeItem("mhet_cnd_token");
//       localStorage.removeItem("mhet_cnd_sid")
//       window.location.href = `/${localStorage.getItem("mhet_cnd_project")}/`;
//       window.location.reload()
//         // yield put({ type: authActions.CANDIDATE_LOGOUT });

//       }
//       // yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
//     }else if(result?.data?.statusCode == 400){

//       localStorage.removeItem("mhet_cnd_token");
//       localStorage.removeItem("mhet_cnd_sid")
//       window.location.href = `/${localStorage.getItem("mhet_cnd_project")}/`;
//       window.location.reload()

//         // yield put({ type: authActions.CANDIDATE_LOGOUT });

//     }
//     // yield delay(2000);
//     // yield put({
//     //   type: commonActions.SET_ALERT,
//     //   payload: { status: null, show: false, message: null },
//     // });
//   } catch (error) {
//     localStorage.removeItem("mhet_cnd_token");
//     window.location.href = `/${localStorage.getItem("mhet_cnd_project")}/login`;
//   }
// };

export default authSagas;









